import { useEffect, useRef, useCallback } from "react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { getPendingOrders, removePendingOrder } from "../lib/offlineOrders";

export const useOfflineOrderSync = (onSynced) => {
  const syncing = useRef(false);

  const sync = useCallback(async () => {
    if (syncing.current || !navigator.onLine) return;
    const pending = getPendingOrders();
    if (pending.length === 0) return;
    syncing.current = true;
    let ok = 0;
    for (const item of pending) {
      try {
        await api.post("/orders", item.payload);
        removePendingOrder(item.localId);
        ok += 1;
      } catch (err) {
        if (err?.response) {
          // Servidor rejeitou (validação/permissão): remove para não travar a fila
          removePendingOrder(item.localId);
          toast.error(`Pedido offline de ${item.client_name || "cliente"} não pôde ser enviado: ${apiError(err)}`);
        }
        // Erro de rede: mantém na fila para a próxima tentativa
      }
    }
    syncing.current = false;
    if (ok > 0) {
      toast.success(`${ok} pedido(s) salvo(s) offline foram sincronizados com sucesso`);
      onSynced && onSynced();
    }
  }, [onSynced]);

  useEffect(() => {
    sync();
    window.addEventListener("online", sync);
    return () => window.removeEventListener("online", sync);
  }, [sync]);

  return sync;
};
